const Component = {

    // FIELDS
    "name": "Name",
    "department": "Department",
    "location": "Location",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "component": "Component",

    // ERROR
    "error_name": "Enter Name",
    "error_department": "Select Department",
    "error_location": "Select Location",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_department": "DEPARTMENT",
    "table_location": "LOCATION",
    "table_status": "STATUS",

}

export default Component;